import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Microscope, Zap } from 'lucide-react';
import './About.css';

const About: React.FC = () => {
  const features = [
    {
      icon: <Brain className="feature-icon" />,
      title: "AI-Powered Analysis",
      description: "Advanced multi-agent systems that understand complex biomedical imaging patterns"
    },
    {
      icon: <Microscope className="feature-icon" />,
      title: "Live-Cell Imaging",
      description: "Specialized algorithms for temporal imaging data analysis and cell behavior tracking"
    },
    {
      icon: <Zap className="feature-icon" />,
      title: "Automated Pipeline",
      description: "Streamlined workflow from raw imaging data to actionable insights"
    }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <motion.div 
          className="about-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Revolutionizing Biomedical Imaging</h2>
          <p className="section-subtitle">
            We're building the next generation of automated bioimaging analysis tools, 
            making complex scientific analysis accessible to researchers without extensive 
            programming or machine learning backgrounds.
          </p>
        </motion.div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <motion.div 
              key={index}
              className="feature-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <div className="feature-icon-wrapper">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;